import React,{ useRef } from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Avatar,Modal,Form,DatePicker,Select,Switch,Space,Typography,Divider,InputNumber,message,Spin,Popover,Popconfirm,Result,Card } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon, { PrinterOutlined, MinusOutlined, CloseCircleFilled, CheckCircleOutlined, UserOutlined,DeleteOutlined,EditOutlined,DownloadOutlined } from '@ant-design/icons';
import { SearchOutlined,CameraOutlined,PlusOutlined,LoadingOutlined,MailFilled } from '@ant-design/icons';
import QrReader from 'react-qr-reader'
import uuid from 'react-uuid'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';
import PrintTemplate from 'react-print';
import ReactToPrint from 'react-to-print';
import * as serverconfig from '../serverconn'
import CurrencyFormat from 'react-currency-format';
import * as reactstrp from 'reactstrap';

import {
  Col,
  Row,
} from 'reactstrap';
import '../tablestyle.css'; // Create this CSS file for custom styles
import ReactExport from "@ibrahimrahmani/react-export-excel";
var converter = require('number-to-words');


var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const { Title } = Typography;
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


var sacco= ''
var bizuserid= ''
var token= ''
var username=''


class ReportToPrint extends React.Component {

  state = {
    companyprofile:{},
  };

  componentDidMount(){

    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
       username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)

    }else{
       sacco= ''
       bizuserid= ''
       username=''

    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })


  }

  render() {
    return (
      <div style={{padding:20}}>
<Row> 
              <Col xs="2" sm="2" lg="2">
              <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />
            
                </Col>
                <Col xs="6" sm="6" lg="6">
                <h3>{this.state.companyprofile.sacco_name}</h3>
                <h6>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
                {
                this.state.companyprofile.RegisteredPhoneNumber2==""?
                "":","+this.state.companyprofile.RegisteredPhoneNumber2
                }
                {
                this.state.companyprofile.RegisteredPhoneNumber3==""?
                "":","+this.state.companyprofile.RegisteredPhoneNumber3
                }
                </h6>               
                <h5>Email: {this.state.companyprofile.company_email}</h5>
                <h5>Wesite: {this.state.companyprofile.website}</h5>
                <h5>{this.state.companyprofile.box_number}</h5>
              
                </Col>
         </Row>

           <h3 style={{display: 'flex',justifyContent:'center', alignItems:'center',fontWeight:'bolder'}}>FINANCIAL STATEMENT REPORT FOR {this.props.selectedmemberobject.AccountNumber} | {this.props.selectedmemberobject.FullName} FROM: {this.props.dateone}  TO: {this.props.datetwo}</h3>


           <reactstrp.Table bordered>
        <thead>
          <tr>
            <th>No</th>
            <th>Date</th>
            <th>Desc</th>
            <th>Sub account</th>

            <th>Debit</th>
            <th>Credit</th>
            

            {this.props.showsavings?<th>Savings balance</th>:null}
            {this.props.showsavings_interest?<th>Savings interest</th>:null}

            {this.props.showshares?<th>Shares #</th>:null}
            {this.props.showshares?<th>Shares Amount</th>:null}
            {this.props.showloan?<th>Loan balance</th>:null}
            {this.props.showloan_interest?<th>Loan interest</th>:null}
            {this.props.showloan_fine? <th>Loan fine</th>:null}

            {this.props.showfixeddeposit? <th>Fixed deposit</th>:null}
            {this.props.showsavingsloansecurity? <th>Savings loan security</th>:null}
            {this.props.show_accumulateddividends? <th>Accumulated dividends</th>:null}

            <th>Journal number</th>

         

          </tr>
        </thead>
        <tbody>
        {this.props.sheetitems.map(
          (item)=>(
            <tr>
            <td>{item.item_no}</td>

            <td>{item.time_stamp}</td>
            <td>{item.description}</td>
            <td>{item.subaccount}</td>


            <td className="align-right">{<CurrencyFormat value={item.debit} displayType={'text'} thousandSeparator={true}/>}</td>
            <td className="align-right">{<CurrencyFormat value={item.credit} displayType={'text'} thousandSeparator={true}/>}</td>
           

            {this.props.showsavings?<td className="align-right">{<CurrencyFormat value={item.savings_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            {this.props.showsavings_interest?<td className="align-right">{<CurrencyFormat value={item.saving_interestbalance} displayType={'text'} thousandSeparator={true}/>}</td>:null}

            {this.props.showshares?<td className="align-right">{item.sharesnumber_balance} </td>:null}
            {this.props.showshares?<td className="align-right">{<CurrencyFormat value={item.sharesamount_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            {this.props.showloan?<td className="align-right">{<CurrencyFormat value={item.loan_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            {this.props.showloan_interest?<td className="align-right">{<CurrencyFormat value={item.loaninterest_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            {this.props.showloan_fine? <td className="align-right">{<CurrencyFormat value={item.loanfine_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}

            {this.props.showfixeddeposit? <td className="align-right">{<CurrencyFormat value={item.fixed_deposit_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            {this.props.showsavingsloansecurity? <td className="align-right">{<CurrencyFormat value={item.savingsloan_security_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            {this.props.show_accumulateddividends? <td className="align-right">{<CurrencyFormat value={item.accumulated_dividendsbalance} displayType={'text'} thousandSeparator={true}/>}</td>:null}

            <td>{item.journal_no} </td>

            </tr>
          ))}

        <tr>



        {this.props.showsavings?<td className="align-right"><h3>Savings: <CurrencyFormat  value={this.props.selectedmemberobject.savings_balance} displayType={'text'} thousandSeparator={true} /></h3> </td>:null}
            {this.props.showsavings_interest?<td className="align-right"><h3>Savings interest: <CurrencyFormat  value={this.props.selectedmemberobject.saving_interestbalance} displayType={'text'} thousandSeparator={true} /></h3> </td>:null}

            {this.props.showshares?<td className="align-right"><h3>Shares no : {this.props.selectedmemberobject.sharesnumber_balance}</h3></td>:null}
            {this.props.showshares?<td className="align-right"> <h3>Shares amount  : <CurrencyFormat  value={this.props.selectedmemberobject.sharesamount_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
            {this.props.showloan?<td className="align-right"><h3>Loan : <CurrencyFormat  value={this.props.selectedmemberobject.loan_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
            {this.props.showloan_interest?<td className="align-right"><h3>Loan interest : <CurrencyFormat  value={this.props.selectedmemberobject.loaninterest_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
            {this.props.showloan_fine? <td className="align-right"><h3>Loan fine : <CurrencyFormat  value={this.props.selectedmemberobject.loanfine_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}

            {this.props.showfixeddeposit? <td className="align-right"><h3>Fixed deposit : <CurrencyFormat  value={this.props.selectedmemberobject.fixed_deposit_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
            {this.props.showsavingsloansecurity? <td className="align-right"><h3>Reserve (Savings loan security) : <CurrencyFormat  value={this.props.selectedmemberobject.savingsloan_security_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
            {this.props.show_accumulateddividends? <td className="align-right"><h3>Accumulated dividends : <CurrencyFormat  value={this.props.selectedmemberobject.accumulated_dividendsbalance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}


            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>

          </tr>

      </tbody>
  </reactstrp.Table>


              <br></br>
              <h3>Generated by: {CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)}</h3>
              <h3>Powered by: www.pitech.co.ug</h3>   
      </div>
    );
  }
}




class ReceiptToPrint_Receipt extends React.Component {

  state = {
    companyprofile:{}
  };

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
    
    }else{
       sacco= ''
       username=''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })

  }

  render() {
    return (
      <div style={{padding:20}}>

      {
        this.props.thermalprint===true?
        <div>
        <p>*********************************************************</p>

        <h1 style={{fontWeight:'bolder',display:'flex',alignSelf:'flex-start'}}>  {this.state.companyprofile.sacco_name}</h1>
        <h2 style={{color:'black'}}>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
        {
        this.state.companyprofile.RegisteredPhoneNumber2==""?
        "":","+this.state.companyprofile.RegisteredPhoneNumber2
        }

        </h2>               
        <h2 style={{color:'black'}}>  Email: {this.state.companyprofile.company_email}</h2>
        <h2 style={{color:'black'}}>  Wesite: {this.state.companyprofile.website}</h2>
        <h2 style={{color:'black'}}>  {this.state.companyprofile.box_number}</h2>
        <h2 style={{color:'black'}}>  SLIP/RECEIPT NO: {this.props.journalno}</h2>
        <h2 style={{color:'black'}}>  DATE: {this.props.date}</h2>

        <p>*********************************************************</p>

        <h1 style={{fontWeight:'bolder',display:'flex',alignSelf:'flex-start'}}>  DEPOSIT RECEIPT</h1>

      </div>

        :

          <div>
            <Row> 
          <Col xs="2" sm="2" lg="2">
          <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />

            </Col>
            <Col xs="6" sm="6" lg="6">
            <h2 style={{fontWeight:'bolder'}}>{this.state.companyprofile.sacco_name}</h2>
            <h3 style={{fontWeight:'bolder'}}>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}</h3>               
            <h3 style={{fontWeight:'bolder'}}>Email: {this.state.companyprofile.company_email}</h3>
            <h3 style={{color:'black',fontWeight:'bolder'}}>  DATE: {this.props.date}</h3>

            </Col>
          </Row>
          <h3 style={{fontWeight:'bolder',display:'flex',alignSelf:'center',alignContent:'center',justifyContent:'center'}}>DEPOSIT RECEIPT (CLIENT COPY)</h3>

          </div>
      }


      {
        this.props.thermalprint===true?
        <div>
             <p>********************************</p>

          <h3>
              ACC NUMBER: 
            {this.props.account.AccountNumber}
          </h3>

          <h3>
              ACC NAME :
            {this.props.account.FullName}
          </h3>

          <h3>
              DEPOSITED AMOUNT:
            <CurrencyFormat  value={this.props.totalamount} displayType={'text'} thousandSeparator={','} />
          </h3>

          <h3>
              In Words: 
            ({ this.props.amount_inwords})
          </h3>


          <h3 >
              PAID IN BY: 
            {this.props.paidinby}
          </h3> 

          <h3 >
              CONTACT:
            {this.props.transactorcontact}
          </h3> 

          <h3 >
              TELLER:  
            {username}
          </h3>                 

          <h3 class="force-line-break">
              PAYMENT OF: 
            {this.props.reason}
          </h3> 

          <h3 class="force-line-break">
              TRANSACTION CHANNEL: 
            {this.props.transaction_channel}
          </h3> 

          <p>********************************</p>

          <h4>  Supported by PitechUgLtd ( www.pitech.co.ug )</h4>
        </div>
        :


        <div>
         <reactstrp.Table bordered>
        <thead>
          <tr>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}> ACC NUMBER</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.account.AccountNumber}</th>
          </tr>

          <tr>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>ACC NAME</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.account.FullName}</th>
          </tr>

          <tr>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>DEPOSITED AMOUNT</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}><CurrencyFormat  value={this.props.totalamount} displayType={'text'} thousandSeparator={true} /></th>
          </tr>

          <tr>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>IN WORDS  </th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>({ this.props.amount_inwords})</th>
          </tr>


          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>PAID IN BY</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.paidinby}</th>
          </tr> 

          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>SLIP NUMBER</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.journalno}</th>
          </tr> 

          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>CONTACT</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.transactorcontact}</th>
          </tr> 

          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>TELLER</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{username}</th>
          </tr>                 

          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>PAYMENT OF</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.reason}</th>
          </tr> 

          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>TRANSACTION CHANNEL</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.transaction_channel}</th>
          </tr> 

        </thead>
          </reactstrp.Table> 

            {
              this.props.print_office_copy?
              <div>
               <Divider style={{ borderStyle: 'dotted' }} />

               <Row> 
                <Col xs="2" sm="2" lg="2">
                <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />

                  </Col>
                  <Col xs="6" sm="6" lg="6">
                  <h2 style={{fontWeight:'bolder'}}>{this.state.companyprofile.sacco_name}</h2>
                  <h3 style={{fontWeight:'bolder'}}>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}</h3>               
                  <h3 style={{fontWeight:'bolder'}}>Email: {this.state.companyprofile.company_email}</h3>
                  <h3 style={{color:'black',fontWeight:'bolder'}}>  DATE: {this.props.date}</h3>

                  </Col>
               </Row>                 
             <h2 style={{fontWeight:'bolder',display:'flex',alignSelf:'center',alignContent:'center',justifyContent:'center',color:'black'}}>DEPOSIT RECEIPT (OFFICE COPY)</h2>

                    <reactstrp.Table bordered>
        <thead>
          <tr>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}> ACC NUMBER</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.account.AccountNumber}</th>
          </tr>

          <tr>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>ACC NAME</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.account.FullName}</th>
          </tr>

          <tr>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>DEPOSITED AMOUNT</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}><CurrencyFormat  value={this.props.totalamount} displayType={'text'} thousandSeparator={true} /></th>
          </tr>

          <tr>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>IN WORDS  </th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>({ this.props.amount_inwords})</th>
          </tr>


          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>PAID IN BY</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.paidinby}</th>
          </tr> 

          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>SLIP NUMBER</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.journalno}</th>
          </tr> 

          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>CONTACT</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.transactorcontact}</th>
          </tr> 

          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>TELLER</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{username}</th>
          </tr>                 

          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>PAYMENT OF</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.reason}</th>
          </tr> 

          <tr >
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>TRANSACTION CHANNEL</th>
            <th style={{fontSize:22,fontWeight:'bolder',color:'black'}}>{this.props.transaction_channel}</th>
          </tr> 

        </thead>
          </reactstrp.Table>

              </div>
              :
              null


            }


        </div>
    }
        
  </div>
    );
  }
}



class FinancialStatementReport extends React.Component {

  state = {
    members:[],    
    sheetitems:[],
    dateone:'',
    datetwo:'',
    selectedmemberobject:{},
    selectedmemberid:'',
    totaldebit:0,
    totalcredit:0,
    datarequested:false,
    companyprofile:{},
    userprofile:{},

    deletelist:[],

    editmodalvisiblae:false,
    selectedtranobj:{},
    credit:0,
    debit:0,
    balance:0,
    transdesc:'',

    sharesamount_balance:0,
    sharesnumber_balance:0,
    loan_balance:0,
    savingsloan_security_balance:0,
    shares_security_balance:0,

    reversalmodal_visible:false,
    selected_journal:{},
    tobereversed_transactions:[],
    loan_txn_report:[],
    general_ledger_entriesreport:[],
    txndetailsmodal_visible:false,
    userrights:{},

    showsavings:false,
    showsavings_interest:false,

    showshares:false,
    showloan:false,
    showloan_interest:false,
    showloan_fine:false,

    showsavingsloansecurity:false,
    showfixeddeposit:false,

    showall:false,
    show_accumulateddividends:false,

    datasubmittedsuccessfully:false,
    current_txn_date:'',
    change_date:false,

    receiptmodal_visible:false,
    current_member_transaction:{},
    total_received:0,
    transaction_channel:''

   };

   componentDidMount(){
      if(localStorage.getItem("sacco")){
        sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
        bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
        username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)

    }else{
        sacco= ''
        bizuserid= ''
        username=''
    }
    
    if(localStorage.getItem("token")){
        token= localStorage.getItem("token")
    }else{
        token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })

    axios.get(serverconfig.backendserverurl+`/api/members_dataview/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          members:res.data
        })
      })

      axios.get(`${serverconfig.backendserverurl}/api/accounts/${bizuserid}`)
      .then(res => {  
          this.setState({
            userprofile: res.data
          })
      })

      axios.get(serverconfig.backendserverurl+`/api/accountrights/?user=${bizuserid}`)
      .then(res => {
          this.setState({
            userrights:res.data[0]
          })
      })


  }
 
   handledatechange= (date, dateString) =>{
     this.setState({ dateone: dateString[0]});
     this.setState({ datetwo: dateString[1]});
   } 

   handlememberChange= (e) =>{
    this.setState({ selectedmemberid: e});

    axios.get(`${serverconfig.backendserverurl}/api/members_dataview/${e}`)
    .then(res => {  
        this.setState({selectedmemberobject: res.data})
    })

   } 

 
   //search sales method
   searchSales=()=>{

    let form_data = new FormData();
    form_data.append('dateone', this.state.dateone);
    form_data.append('datetwo', this.state.datetwo);
    form_data.append('memberid', this.state.selectedmemberid);
    form_data.append('sacco', sacco);

    form_data.append('showall', this.state.showall);

    form_data.append('showsavings', this.state.showsavings);
    form_data.append('showshares', this.state.showshares);

    form_data.append('showloan', this.state.showloan);
    form_data.append('showsavingsloansecurity', this.state.showsavingsloansecurity);
    form_data.append('showfixeddeposit', this.state.showfixeddeposit);

    form_data.append('showloan_interest', this.state.showloan_interest);
    form_data.append('showloan_fine', this.state.showloan_fine);
    form_data.append('showsavings_interest', this.state.showsavings_interest);
    form_data.append('show_accumulateddividends', this.state.show_accumulateddividends);

    console.log(this.state.entrant)
      
    if(this.state.selectedmemberid===''||this.state.dateone===''||this.state.datetwo===''){
      alert("Please select entrant or dates missing")
    }else{
        this.setState({datarequested:true})

        //Now submit sale data to database
        axios.post(serverconfig.backendserverurl+'/customqueries/getmemberfinancialstatement', form_data,{
        headers: {
          'content-type': 'multipart/form-data'
        }
        })
        .then(res =>{
          this.setState({datarequested:false})

            this.setState({sheetitems:JSON.parse(res.data.report)})
            this.setState({totaldebit:res.data.totalDebit})
            this.setState({totalcredit:res.data.totalCredit})
        } 
        )
        .catch(error => console.log(error))   
    }

    }

   ////////////////////////////////////
  // USER SEARCH SELECT METHODS
  onBlur=()=> {
    console.log('blur');
  }
  
   onFocus=()=>{
    console.log('focus');
  }
  
  onSearch=(val)=> {
    console.log('search:', val);
  }
 

   ////////////////////////////////////////////
   // RENDERING METHOD HERE
   render() {
       
       if(this.state.datarequested===true){
        return(
          <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
              <div className="content">
                <h3>Pisacco</h3>
              </div>
               </Spin> 
           </div>
        )
      }else{

        if (this.state.datasubmittedsuccessfully===true){
          return(

          <Card>
            <Result
            status="success"
            title="Action successful"
            extra={[
            
              <Button  type='primary' 
              onClick={()=>{
                //get financial statement again
                this.searchSales()

                axios.get(`${serverconfig.backendserverurl}/api/members/${this.state.selectedmemberid}`)
                .then(res => {  
                    this.setState({selectedmemberobject: res.data})
                })
                //updated balance
                window.location.reload(false)
              
              }}>Finish</Button>
            ]}
            />

            </Card>
            )


        }else{

          return(
            <div>
              <div style={{display: "none"}}>
                 &nbsp;&nbsp;
                <ReportToPrint
                totaldebit={this.state.totaldebit} 
                totalcredit={this.state.totalcredit} 
                dateone={this.state.dateone}
                datetwo={this.state.datetwo}
                sheetitems={this.state.sheetitems}
                selectedmemberobject={this.state.selectedmemberobject}
  
                showsavings={this.state.showsavings}
                showsavings_interest={this.state.showsavings_interest}
                showshares={this.state.showshares}
                showloan={this.state.showloan}
                showloan_interest={this.state.showloan_interest}
                showloan_fine={this.state.showloan_fine}
                showsavingsloansecurity={this.state.showsavingsloansecurity}
                showfixeddeposit={this.state.showfixeddeposit}
                showall={this.state.showall}
                show_accumulateddividends={this.state.show_accumulateddividends}

                ref={el => (this.componentRef = el)} /> 
              </div>


              <div style={{display: "none"}}>
                &nbsp;&nbsp;
                <ReceiptToPrint_Receipt
                account={this.state.selectedmemberobject} 
                totalamount={this.state.total_received} 
                amount_inwords={converter.toWords(this.state.total_received)}
                thermalprint={false}

                paidinby={this.state.current_member_transaction.transacted_by} 
                transactorcontact={this.state.current_member_transaction.transactor_contact}
                date={this.state.current_member_transaction.date}
                reason={this.state.current_member_transaction.description}
                journalno={this.state.current_member_transaction.journal_no}
                extra_deposit_list={[]}
                print_office_copy={true}
                transaction_channel={this.state.transaction_channel}

                ref={el => (this.componentRef_1 = el)} 
                /> 
                  </div>    


              <Collapse defaultActiveKey={['1']} onChange={this.callback}>
              <Panel header="MEMBER FINANCIAL STATEMENT REPORT" key="1">
  
  <div style={{display:'flex',justifyContent:'flex-start'}}>
                
  <ReactToPrint
    trigger={() => 
    <Button type="primary"  shape="round" icon={<PrinterOutlined />} size={this.state.size}>
    Print
    </Button>
    }
    content={() => this.componentRef}
    />
    &nbsp;
    &nbsp;
    &nbsp;
    &nbsp;
    &nbsp;
  
  <Button type='primary'
    icon={<MailFilled/>}
    
    onClick={
    ()=>{
      let form_data = new FormData();
      form_data.append('dateone', this.state.dateone);
      form_data.append('datetwo', this.state.datetwo);
      form_data.append('memberid', this.state.selectedmemberid);
      form_data.append('sacco', sacco);
  
      form_data.append('showall', this.state.showall);
  
      form_data.append('showsavings', this.state.showsavings);
      form_data.append('showshares', this.state.showshares);
  
      form_data.append('showloan', this.state.showloan);
      form_data.append('showsavingsloansecurity', this.state.showsavingsloansecurity);
      form_data.append('showfixeddeposit', this.state.showfixeddeposit);
  
      form_data.append('showloan_interest', this.state.showloan_interest);
      form_data.append('showloan_fine', this.state.showloan_fine);
      form_data.append('showsavings_interest', this.state.showsavings_interest);
      form_data.append('show_accumulateddividends', this.state.show_accumulateddividends);

      console.log(this.state.entrant)
        
      if(this.state.selectedmemberid===''||this.state.dateone===''||this.state.datetwo===''){
        alert("Please select entrant or dates missing")
      }else{
          this.setState({datarequested:true})
  
          //Now submit sale data to database
          axios.post(serverconfig.backendserverurl+'/customqueries/emailmemberfinancialstatement', form_data,{
          headers: {
            'content-type': 'multipart/form-data'
          }
          })
          .then(res =>{
            this.setState({datarequested:false})
            message.info(res.data.message)
          } 
          )
          .catch(error => console.log(error))   
      }
    }
    }
    
    >
    Send via eMail
  </Button>
  
  &nbsp;&nbsp;
  
  <ExcelFile filename={"Pisacco - Financial statement report for "+this.state.selectedmemberobject.FullName+" from "+this.state.dateone+" to "+this.state.datetwo}  element={<Button type='primary' icon={<DownloadOutlined/>}>Download (Excel)</Button>}>
    <ExcelSheet data={this.state.sheetitems} name={"Financial statement report"}>
        <ExcelColumn label="Date" value="time_stamp"/>
        <ExcelColumn label="Description" value="description"/>
  
        <ExcelColumn label="Sub account" value="subaccount"/>
        <ExcelColumn label="Debit" value="debit"/>
        <ExcelColumn label="Credit" value="credit"/>
        <ExcelColumn label="Savings balance" value="savings_balance"/>
        <ExcelColumn label="Savings interest" value="saving_interestbalance"/>
  
        <ExcelColumn label="Shares No" value="sharesnumber_balance"/>
        <ExcelColumn label="Shares Amount" value="sharesamount_balance"/>
        <ExcelColumn label="Loan balance" value="loan_balance"/>
        <ExcelColumn label="Loan interest" value="loaninterest_balance"/>
        <ExcelColumn label="Loan fine" value="loanfine_balance"/>
        <ExcelColumn label="Fixed deposit" value="fixed_deposit_balance"/>
        <ExcelColumn label="Savings loan security" value="savingsloan_security_balance"/>
        <ExcelColumn label="Accumulated dividends" value="accumulated_dividendsbalance"/>

        <ExcelColumn label="Journal number" value="journal_no"/>
  
    </ExcelSheet>
  </ExcelFile>
  
  
  </div>
  <br></br>
  <br></br>
  
  <Form  layout="inline" >
  <FormItem label="Members">
         <Select 
         placeholder="Account"
         style={{ width: 300 }} 
         value={this.state.selectedmemberid} 
         onChange={this.handlememberChange}
          
         showSearch
         optionFilterProp="children"
         onFocus={this.onFocus}
         onBlur={this.onBlur}
         onSearch={this.onSearch}                     
          >
           {this.state.members.map(
             (member)=>{
  
                return (
                  <Option value={member.id}>{member.AccountNumber} | {member.FullName}</Option>
                );
         
             })}
         </Select>
     </FormItem>
  
  
      <FormItem label="Date Range">
          <RangePicker defaultValue={moment()} onChange={this.handledatechange} format={dateFormat} />
      </FormItem>
  
      <FormItem>
      <Button onClick={this.searchSales} type="primary" htmlType="button">Search</Button>
      </FormItem> 
  
  </Form>
  
  <br></br>
  <Form layout='inline'>
  
  <FormItem name="showall" label="Show all" >
                          <Switch
                              checked={this.state.showall}
                              onChange={val=>{
                                this.setState({showall:val})
  
                                if (val===true){
                                  this.setState({showsavings:true})
                                  this.setState({showsavings_interest:true})
  
                                  this.setState({showshares:true})
                                  this.setState({showsavingsloansecurity:true})
                                  this.setState({showfixeddeposit:true})
  
                                  this.setState({showloan:true})
                                  this.setState({showloan_fine:true})
                                  this.setState({showloan_interest:true})
                                  
                                  if(this.state.companyprofile.accumulated_dividends_active===true){
                                    this.setState({show_accumulateddividends:true})
  
                                  }
  
                                }else{
                                  this.setState({showsavings:false})
                                  this.setState({showsavings_interest:false})
  
                                  this.setState({showshares:false})
                                  this.setState({showsavingsloansecurity:false})
                                  this.setState({showfixeddeposit:false})
  
                                  this.setState({showloan:false})
                                  this.setState({showloan_fine:false})
                                  this.setState({showloan_interest:false})  

                                if(this.state.companyprofile.accumulated_dividends_active===true){

                                this.setState({show_accumulateddividends:false})
                                }

                                  }

                              }}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                          />
                      </FormItem>
  
                     <FormItem name="showsavings" label="Show savings" >
                          <Switch
                              checked={this.state.showsavings}
                              onChange={val=>{this.setState({showsavings:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                          />
                      </FormItem>
  
  
                      <FormItem name="showsavings_interest" label="Show savings interest" >
                          <Switch
                              checked={this.state.showsavings_interest}
                              onChange={val=>{this.setState({showsavings_interest:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                          />
                      </FormItem>
  
                      <FormItem name="showshares" label="Show shares" >
                          <Switch
                              checked={this.state.showshares}
                              onChange={val=>{this.setState({showshares:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                          />
                      </FormItem>
  
                      <FormItem name="showloan" label="Show loan" >
                          <Switch
                              checked={this.state.showloan}
                              onChange={val=>{this.setState({showloan:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                          />
                      </FormItem>
  
                      <FormItem name="showloan_interest" label="Show loan interest" >
                          <Switch
                              checked={this.state.showloan_interest}
                              onChange={val=>{this.setState({showloan_interest:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                          />
                      </FormItem>
  
                      <FormItem name="showloan_fine" label="Show loan fine" >
                          <Switch
                              checked={this.state.showloan_fine}
                              onChange={val=>{this.setState({showloan_fine:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                          />
                      </FormItem>
   
                      <FormItem name="showsavingsloansecurity" label="Show savings loan security (Reserve)" >
                          <Switch
                              checked={this.state.showsavingsloansecurity}
                              onChange={val=>{this.setState({showsavingsloansecurity:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                          />
                      </FormItem>
  
  
                      <FormItem name="showfixeddeposit" label="Show fixed deposit" >
                          <Switch
                              checked={this.state.showfixeddeposit}
                              onChange={val=>{this.setState({showfixeddeposit:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                          />
                      </FormItem>

                      {
                        this.state.companyprofile.accumulated_dividends_active?
                        <FormItem name="show_accumulateddividends" label="Show accumulated dividends" >
                          <Switch
                              checked={this.state.show_accumulateddividends}
                              onChange={val=>{this.setState({show_accumulateddividends:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                          />
                        </FormItem>
                        :
                        null
                      }

  </Form>
  
  

  
  <br></br>
  <div style={{overflowX : 'auto'}}>
  <reactstrp.Table bordered>
          <thead>
            <tr>
              <th>No</th>
              <th>Date</th>
              <th>Desc</th>
              <th>Sub account</th>
  
              <th>Debit</th>
              <th>Credit</th>
              
  
              {this.state.showsavings?<th>Savings balance</th>:null}
              {this.state.showsavings_interest?<th>Savings interest</th>:null}
  
              {this.state.showshares?<th>Shares #</th>:null}
              {this.state.showshares?<th>Shares Amount</th>:null}
              {this.state.showloan?<th>Loan balance</th>:null}
              {this.state.showloan_interest?<th>Loan interest</th>:null}
              {this.state.showloan_fine? <th>Loan fine</th>:null}
  
              {this.state.showfixeddeposit? <th>Fixed deposit</th>:null}
              {this.state.showsavingsloansecurity? <th>Savings loan security</th>:null}
              {this.state.show_accumulateddividends? <th>Accumulated dividends</th>:null}

              <th>Journal number</th>
  
              {
              this.state.companyprofile.allow_transaction_reversal===true && this.state.userrights.can_make_transaction_reversals===true?
                <th>Reverse</th>
              :
              null
             }

             <th>Print receipt</th>
  
            </tr>
          </thead>
          <tbody>
          {this.state.sheetitems.map(
            (item)=>(
              <tr>
              <td>{item.item_no}</td>
  
              <td>{item.time_stamp}</td>
              <td>{item.description}</td>
              <td>{item.subaccount}</td>
  
  
              <td className="align-right">{<CurrencyFormat value={item.debit} displayType={'text'} thousandSeparator={true}/>}</td>
              <td className="align-right">{<CurrencyFormat value={item.credit} displayType={'text'} thousandSeparator={true}/>}</td>
             
  
              {this.state.showsavings?<td className="align-right">{<CurrencyFormat value={item.savings_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
              {this.state.showsavings_interest?<td className="align-right">{<CurrencyFormat value={item.saving_interestbalance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
  
              {this.state.showshares?<td className="align-right">{item.sharesnumber_balance} </td>:null}
              {this.state.showshares?<td className="align-right">{<CurrencyFormat value={item.sharesamount_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
              {this.state.showloan?<td className="align-right">{<CurrencyFormat value={item.loan_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
              {this.state.showloan_interest?<td className="align-right">{<CurrencyFormat value={item.loaninterest_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
              {this.state.showloan_fine? <td className="align-right">{<CurrencyFormat value={item.loanfine_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
  
              {this.state.showfixeddeposit? <td className="align-right">{<CurrencyFormat value={item.fixed_deposit_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
              {this.state.showsavingsloansecurity? <td className="align-right">{<CurrencyFormat value={item.savingsloan_security_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
              {this.state.show_accumulateddividends? <td className="align-right">{<CurrencyFormat value={item.accumulated_dividendsbalance} displayType={'text'} thousandSeparator={true}/>}</td>:null}

              <td>{item.journal_no} </td>

            {
              this.state.companyprofile.allow_transaction_reversal && this.state.userrights.can_make_transaction_reversals?
              <th><Button type='primary' onClick={()=>{
                this.setState({current_txn_date:item.date})
  
                //make qery now
                let form_data = new FormData();
                form_data.append('date',item.date);
                form_data.append('selectedmemberid', this.state.selectedmemberid);
                form_data.append('journalno', item.journal_no);
                form_data.append('sacco', sacco);
          
                axios.post(serverconfig.backendserverurl+'/customqueries/queryreversal_transactions', form_data, {
                  headers: {
                    'content-type': 'multipart/form-data'
                  }
                  })
                .then(res => {
                  this.setState({tobereversed_transactions:JSON.parse(res.data.txn_report)})
                  this.setState({loan_txn_report:JSON.parse(res.data.loan_txn_report)})
                  this.setState({general_ledger_entriesreport:JSON.parse(res.data.general_ledger_entriesreport)})
  
                })
                .catch(error => console.log(error))
  
  
                this.setState({reversalmodal_visible:true})
                this.setState({selected_journal:item})
  
  
              }}>Reverse</Button></th>
              :
              null
            }

            <td>
            <Button type="primary"  shape="round" icon={<PrinterOutlined />}
            onClick={()=>{
              this.setState({current_member_transaction:item})
              this.setState({current_txn_date:item.date})
  
              //make qery now
              let form_data = new FormData();
              form_data.append('date',item.date);
              form_data.append('selectedmemberid', this.state.selectedmemberid);
              form_data.append('journalno', item.journal_no);
              form_data.append('sacco', sacco);
        
              axios.post(serverconfig.backendserverurl+'/customqueries/queryreversal_transactions', form_data, {
                headers: {
                  'content-type': 'multipart/form-data'
                }
                })
              .then(res => {
                this.setState({tobereversed_transactions:JSON.parse(res.data.txn_report)})
                this.setState({loan_txn_report:JSON.parse(res.data.loan_txn_report)})
                this.setState({general_ledger_entriesreport:JSON.parse(res.data.general_ledger_entriesreport)})

                this.setState({total_received:res.data.total_received})
                this.setState({transaction_channel:res.data.transaction_channel})

                

              })
              .catch(error => console.log(error))

              this.setState({receiptmodal_visible:true})
              this.setState({selected_journal:item})


            }}
          
            >
            Print
           </Button>
              
           </td>

            </tr>
            ))}
  
          <tr>

  
          {this.state.showsavings?<td className="align-right"><h3>Savings: <CurrencyFormat  value={this.state.selectedmemberobject.savings_balance} displayType={'text'} thousandSeparator={true} /></h3> </td>:null}
              {this.state.showsavings_interest?<td className="align-right"><h3>Savings interest: <CurrencyFormat  value={this.state.selectedmemberobject.saving_interestbalance} displayType={'text'} thousandSeparator={true} /></h3> </td>:null}
  
              {this.state.showshares?<td className="align-right"><h3>Shares no : {this.state.selectedmemberobject.sharesnumber_balance}</h3></td>:null}
              {this.state.showshares?<td className="align-right"> <h3>Shares amount  : <CurrencyFormat  value={this.state.selectedmemberobject.sharesamount_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
              {this.state.showloan?<td className="align-right"><h3>Loan : <CurrencyFormat  value={this.state.selectedmemberobject.loan_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
              {this.state.showloan_interest?<td className="align-right"><h3>Loan interest : <CurrencyFormat  value={this.state.selectedmemberobject.loaninterest_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
              {this.state.showloan_fine? <td className="align-right"><h3>Loan fine : <CurrencyFormat  value={this.state.selectedmemberobject.loanfine_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
  
              {this.state.showfixeddeposit? <td className="align-right"><h3>Fixed deposit : <CurrencyFormat  value={this.state.selectedmemberobject.fixed_deposit_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
              {this.state.showsavingsloansecurity? <td className="align-right"><h3>Reserve (Savings loan security) : <CurrencyFormat  value={this.state.selectedmemberobject.savingsloan_security_balance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
              {this.state.show_accumulateddividends? <td className="align-right"><h3>Accumulated dividends : <CurrencyFormat  value={this.state.selectedmemberobject.accumulated_dividendsbalance} displayType={'text'} thousandSeparator={true} /></h3></td>:null}
  
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
  
            </tr>
  
        </tbody>
    </reactstrp.Table>
  
  </div>
  
  
  </Panel>
</Collapse>

  
              <Modal              
                visible={this.state.reversalmodal_visible}
                title={"Transaction reversal details (All transactions with same journal number)"}
                onCancel={()=>{this.setState({reversalmodal_visible:false})}}
                //style={{width:1000}}
                width={1500}
                footer={[
                 
                 <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-end'}}>
                  <Button type='default' key="back" onClick={()=>{this.setState({reversalmodal_visible:false})}}>
                  Cancel    
                 </Button>

                  <div style={{marginLeft:3,
                      marginRight:3,
                  }}>

                    <FormItem name="change_date" label="Update date" >
                      <Switch
                          checked={this.state.change_date}
                          onChange={val=>{this.setState({change_date:val})}}
                          checkedChildren="Yes"
                          unCheckedChildren="No"
                      />
                    </FormItem>

                    {
                      this.state.change_date===true?
                      <div>
                      <FormItem label={"Date ("+this.state.current_txn_date+")"}>
                        <DatePicker onChange={(date, dateString)=>{this.setState({ current_txn_date: dateString})}} format={dateFormat} />
                      </FormItem>

                      <Button type='primary' key="back" onClick={()=>{
                        if (this.state.current_txn_date===""){
                          message.error("Please select date")
                        }else{

                        //make qery now
                        let form_data = new FormData();
                        form_data.append('current_txn_date',this.state.current_txn_date);
                        form_data.append('selectedmemberid', this.state.selectedmemberid);
                        form_data.append('journalno', this.state.selected_journal.journal_no);
                        form_data.append('username', username);

                        form_data.append('sacco', sacco);
                        this.setState({datarequested:true})

                        axios.post(serverconfig.backendserverurl+'/customqueries/confirmtransaction_date_reversal', form_data,{
                          headers: {
                            'content-type': 'multipart/form-data'
                          } })
                        .then(res => {
                            console.log(res.data)
                            this.setState({datarequested:false})
                            this.setState({datasubmittedsuccessfully:true})

                        })
                        .catch(error => console.log(error))

                        this.setState({reversalmodal_visible:false})

                        }

                      }}>
                      Update date 
                      </Button>

                      </div>

                      :
                      null
                    }

                  </div>


                  <Button  type='primary' key="ok" onClick={()=>{
  
                  //make qery now
                  let form_data = new FormData();
                  form_data.append('date',this.state.selected_journal.date);
                  form_data.append('selectedmemberid', this.state.selectedmemberid);
                  form_data.append('journalno', this.state.selected_journal.journal_no);
                  form_data.append('sacco', sacco);
                  form_data.append('username', username);

                  this.setState({datarequested:true})


                  axios.post(serverconfig.backendserverurl+'/customqueries/confirmtransaction_revsersal', form_data,{
                    headers: {
                      'content-type': 'multipart/form-data'
                    }
                    })
                  .then(res => {
                      console.log(res.data)
                      this.setState({datarequested:false})

                      this.setState({datasubmittedsuccessfully:true})


                  })
                  .catch(error => console.log(error))

                  this.setState({reversalmodal_visible:false})
                  
                  }}>
                  Confirm reversal
                </Button>

                 </div>
                 
               



                  ]}
                  >
                    <div>
                      <h3>Member statement transactions</h3>
                    <reactstrp.Table bordered>
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Desc</th>
                            <th>Sub account</th>
                            <th>Debit</th>
                            <th>Credit</th>
                            <th>Journal number</th>
                          </tr>
                        </thead>
                        <tbody>
                        {this.state.tobereversed_transactions.map(
                          (item)=>(
                            <tr>
                            <td>{item.time_stamp}</td>
                            <td>{item.description}</td>
                            <td>{item.subaccount}</td>
                            <td className="align-right">{<CurrencyFormat value={item.debit} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td className="align-right">{<CurrencyFormat value={item.credit} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{item.journal_no} </td>
                            </tr>
                            ))}
  
                      </tbody>
                  </reactstrp.Table>
                  <Divider />
                  <h3>Loan track transactions</h3>
                        <reactstrp.Table bordered>
                                <thead>
                                  <tr>
                                  <th>Date</th>
                                  <th>User</th>
                                  <th>Desc</th>
                                  <th>Principle Paid</th>
                                  <th>Interest Paid</th>
                                  <th>Fine Paid</th>
                                  <th>Total Paid</th>
                                  <th>Principle Balance</th>
                                  <th>Interest Balance</th>
                                  <th>Total Balance</th>
  
                                  </tr>
                                </thead>
                                <tbody>
                                {this.state.loan_txn_report.map(
                                  (item)=>(
                                    <tr>
                                    <td>{item.date}</td>
                                    <td>{item.user==null?item.payment_by:item.user}</td>
                                    <td>{item.description}</td>
                                    <td className="align-right">{<CurrencyFormat value={item.principle_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                                    <td className="align-right">{<CurrencyFormat value={item.interest_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                                    <td className="align-right">{<CurrencyFormat value={item.fine_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                                    <td className="align-right">{<CurrencyFormat value={item.total_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                                    <td className="align-right">{<CurrencyFormat value={item.principle_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                                    <td className="align-right">{<CurrencyFormat value={item.interest_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                                    <td className="align-right">{<CurrencyFormat value={item.loan_balance} displayType={'text'} thousandSeparator={true}/>}</td>
  
                                    </tr>
                                  ))}
                             
                              </tbody>
                          </reactstrp.Table>
                          <Divider />
                          <h3>General ledger transactions</h3>
                          <reactstrp.Table bordered>
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Account</th>
                            <th>Desc</th>
                            <th>User</th>
                            <th>Debit</th>
                            <th>Credit</th>
                            <th>Journal No</th>
  
                          </tr>
                        </thead>
                        <tbody>
                          
                          {this.state.general_ledger_entriesreport.map(
                          (item)=>(
                            <tr>
                            <td>{item.date}</td>
                            <td>{item.account}</td>
                            <td>{item.description}</td>
                            <td>{item.user}</td>
                            <td className="align-right">{<CurrencyFormat value={item.Debit} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td className="align-right">{<CurrencyFormat value={item.Credit} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{item.journal_no}</td>
  
                            </tr>
                          ))}
                         
                      </tbody>
                   </reactstrp.Table> 
  
                    </div>
                 </Modal> 



                 <Modal              
                  visible={this.state.receiptmodal_visible}
                  title={"Receipt print"}
                  onCancel={()=>{this.setState({receiptmodal_visible:false})}}
                  //style={{width:1000}}
                  width={1500}
                  footer={[
                 
                  <Button type='default' key="back" 
                  onClick={()=>{this.setState({receiptmodal_visible:false})}}>
                  Cancel    
                 </Button>,

                    <ReactToPrint
                    trigger={() => 
                    <Button type="primary"  shape="round" icon={<PrinterOutlined />} size={this.state.size}>
                    Print 
                    </Button>
                    }
                    content={() => this.componentRef_1}
                    />

                  ]}
                  >

                <ReceiptToPrint_Receipt
                account={this.state.selectedmemberobject} 
                totalamount={this.state.total_received} 
                amount_inwords={converter.toWords(this.state.total_received)}
                thermalprint={false}

                paidinby={this.state.current_member_transaction.transacted_by} 
                transactorcontact={this.state.current_member_transaction.transactor_contact}
                date={this.state.current_member_transaction.date}
                reason={this.state.current_member_transaction.description}
                journalno={this.state.current_member_transaction.journal_no}
                extra_deposit_list={[]}
                print_office_copy={true}
                transaction_channel={this.state.transaction_channel}

                ref={el => (this.componentRef_1 = el)} 
                /> 


                 </Modal> 

            </div>
        ) 

        }
       

      }
   
   }
}

export default FinancialStatementReport; 
